import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/grupo/${id}`)
}
export async function getPerfis (dados) {
  return sessaoFetchLoading(`base`, `/grupo?` + serialize(dados), 'GET')
}
export async function getPerfisLista (dados) {
  return sessaoFetchLoading(`base`, `/grupos?` + serialize(dados), 'GET')
}
export async function perfisSelect () {
  return sessaoFetchLoading(`base`, `/grupo?all=1`)
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/grupo`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/grupo/${dados.id}`, 'PUT', dados)
}
export async function editPerfil (dados) {
  return sessaoFetchLoading(`base`, `/grupo/${dados.id}/perfil`, 'PUT', dados)
}
export async function addPadrao (dados) {
  // dados => dados da empresa q deve receber os perfis padrao
  return sessaoFetchLoading(`base`, `/grupo/padrao`, 'POST', dados)
}
export async function delPerfil (dados) {
  let retorno = await sessaoFetchLoading(`consig`, `/grupos/${dados}`, 'DELETE')
  return retorno
}
export async function delPerfilForcado (dados) {
  let retorno = await sessaoFetchLoading(`consig`, `/grupos/DeletarGrupoForcado/${dados}`, 'DELETE')
  return retorno
}



// WEBPACK FOOTER //
// ./src/api/perfil.js